<template>
  <div class="t-pro-detail_titles">
    <p class="title"
      :class="[
        {'title_isdetail': inDetail},
        {'bmfind_title': bmfind},
        {'smallCard_title': smallCard}
      ]"
    >{{ title }}</p>
    <p class="subtitle" :class="[
          {'subtitle_isdetail': inDetail},
          {'smallCard_subtitle': smallCard}
    ]">{{ subtitle }}</p>
    <div class="tags"
        :class="[
        {'tags_isdetail': inDetail},
        {'smallCard_tags': smallCard}
        ]"
        v-if="mark && mark.length > 0"
    >
      <t-tag :txt="item.name"
              v-for="(item, index) in mark"
              :key="index"
              :redColor="item.flag === 1"
              :goldTag="item.flag === 1"
              :smallCard="smallCard"
      ></t-tag>
    </div>
    <div v-if="price" style="text-align: center;">
      <t-price :price="price" :inDetail="inDetail" :smallCard="smallCard" :unit="unit"></t-price>
    </div>
    <div class="pro_id" v-if="id">产品编号：{{ id }}</div>
  </div>
</template>

<script>
import TTag from '@/components/TTag'
import TPrice from '@/components/TPrice'
export default {
  name: 't-pro-detail-titles',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    smallCard: {
      type: Boolean,
      default: false
    },
    bmfind: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: 'subtitle'
    },
    mark: {
      type: Array,
      default: () => []
    },
    price: {
      type: String
    },
    id: {
      type: Number
    },
    inDetail: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: '人'
    }
  },
  components: {
    TTag,
    TPrice
  }
}
</script>

<style lang="less" scoped>
.t-pro-detail_titles {
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 11px;
  .title {
    padding: 0 10px;
    margin-top: 16px;
    // font-family: PingFangSC-Regular;
    font-size: 15px;
    letter-spacing: 0.9px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .bmfind_title {
    line-height: 24px;
  }
  .title_isdetail {
    // @include XXXL_Gray_1C();
    // font-family: PingFangSC-Light;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 18px;
  }
  .smallCard_title {
    // @include M_Gray_1M();
    // font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #333333;
    letter-spacing: 0;
    line-height: 13px;

  }
  .subtitle {
    padding: 0 10px;
    margin-top: 10px;
    // font-family: PingFangSC-Light;
    font-size: 12px;
    color: #898989;
    letter-spacing: 0.3px;
    text-align: center;
    // @include S_Gray_2C();
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .subtitle_isdetail {
    margin-top: 15px;
    // @include S_Gray_1C();
    // font-family: PingFangSC-Light;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 12px;
    // font-size: 12px;
  }
  .smallCard_subtitle {
    margin-top: 8px;
    // @include S_Gray_2();
    // font-family: PingFangSC-Light;
    font-size: 12px;
    color: #898989;
    letter-spacing: 0.3px;
    line-height: 12px;
  }
  .tags {
    margin: 10px auto 15px;
    display: flex;
    justify-content: center;
  }
  // .smallCard_tags {
  //   margin:
  // }
  .tags_isdetail {
    margin: 15px auto 30px;
  }
  .pro_id {
    padding-top: 11px;
    position: absolute;
    right: 20px;
    // @include S_Gray_3();
    // font-family: PingFangSC-Light;
    font-size: 12px;
    color: #BEBEBE;
    letter-spacing: 0.3px;
    line-height: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TProDetailTitles.vue